interface PartiesKpiCardProps {
  label: string;
  value: string;
  icon: string;
  color: "primary" | "accent" | "secondary" | "warning" | "danger";
  subtitle?: string;
}

const colorMap = {
  primary: "bg-primary-50 text-primary-600",
  accent: "bg-accent-50 text-accent-600",
  secondary: "bg-secondary-50 text-secondary-600",
  warning: "bg-warning-50 text-warning-600",
  danger: "bg-danger-50 text-danger-600",
};

export default function PartiesKpiCard({ label, value, icon, color, subtitle }: PartiesKpiCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4 hover:border-background-300 transition-colors">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${colorMap[color]}`}>
          <i className={`${icon} w-full h-full flex items-center justify-center text-lg`} />
        </div>
        <div className="min-w-0">
          <p className="text-xs text-foreground-500 truncate">{label}</p>
          <p className="text-xl font-bold text-foreground-900 font-heading mt-0.5">{value}</p>
          {subtitle && <p className="text-xs text-foreground-400 mt-0.5">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
}